import React, { useState, useEffect } from 'react';
import { fetchAreaPriceChange } from './areaPriceTrend.js';

// A small "↗ +12 % i området" pill for the listvy listing card: the area's price change over the last 3
// years (DEFAULT_TREND_YEARS), fetched (cached per area+type) from /price-history/area. Renders nothing
// until there's data, so cards in areas without enough sales are unchanged.

const seriesType = (listingType) => {
    const type = String(listingType || '').toLowerCase();
    if (type.includes('fritidshus')) return 'fritidshus';
    if (type.includes('house++') || type.includes('radhus') || type.includes('rowhouse')) return 'house++';
    if (type.includes('house') || type.includes('villa')) return 'house';
    return 'apartment';
};

export default function AreaTrendPill({ regso, type, swedish }) {
    const [change, setChange] = useState(null);
    useEffect(() => {
        let alive = true;
        setChange(null);
        if (regso) {
            fetchAreaPriceChange(regso, seriesType(type)).then((result) => { if (alive) setChange(result); });
        }
        return () => { alive = false; };
    }, [regso, type]);

    if (!change || change.change == null) return null;
    const up = change.change >= 0;
    const title = change.full
        ? (swedish ? `Prisutveckling i området sedan ${change.startYear}` : `Area price trend since ${change.startYear}`)
        : (swedish ? `Prisutveckling i området, senaste ${change.years} åren` : `Area price trend, last ${change.years} years`);
    return (
        <span className={`area-trend-pill${up ? '' : ' is-down'}`} title={title}>
            <span className="area-trend-pill-arrow" aria-hidden="true">{up ? '↗' : '↘'}</span>
            {`${up ? '+' : '−'}${Math.abs(change.change)} % ${swedish ? 'i området' : 'in the area'}`}
        </span>
    );
}
